import React from "react";
import PropTypes from "prop-types";
import { InputField, TextareaField } from "../../FormField";
import { SelectField } from "cxa-form-field";
import RadioButtonGroup from "../common/RadioButtonGroup";

const Part5 = ({ data }) => {
  return (
    <table
      style={{
        margin: "10px 0px",
        width: "100%",
        borderCollapse: "collapse",
        border: "1px solid #000",
      }}
    >
      <tbody>
        <tr>
          <td
            style={{
              fontWeight: "bold",
              backgroundColor: "#edb8be",
              paddingLeft: 10,
              borderBottom: "1px solid #000",
            }}
          >
            V)&nbsp;PARTICULARS of HEALTH of the EMPLOYEE / ELIGIBLE MEMBER (and DEPENDANT(S) IF
            APPLICABLE)
          </td>
        </tr>
        <tr>
          <td>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <td
                    rowSpan={3}
                    style={{
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      width: "60%",
                    }}
                  >
                    <div style={{ color: "#f00" }}>
                      Please tick Yes or No.{" "}
                      <span style={{ fontWeight: "bold" }}>
                        If Yes, please provide details under Section VI.
                      </span>
                    </div>
                  </td>
                  <td
                    rowSpan={2}
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      verticalAlign: "bottom",
                    }}
                    colSpan={2}
                  >
                    Employee
                  </td>
                  <td
                    style={{
                      color: "#f00",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                      textAlign: "center",
                    }}
                    colSpan={4}
                  >
                    Answer ONLY IF to be insured
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    colSpan={2}
                  >
                    Spouse
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderRight: "1px solid #000",
                      borderBottom: "1px solid #000",
                    }}
                    colSpan={2}
                  >
                    Child(ren)
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                    }}
                  >
                    Yes
                  </td>
                  <td
                    style={{
                      textAlign: "center",
                      borderBottom: "1px solid #000",
                      borderRight: "1px solid #000",
                    }}
                  >
                    No
                  </td>
                </tr>
                <RadioButtonGroup
                  key={1}
                  data={data}
                  groupNumber={1}
                  questions={[
                    "a) Has any proposal for life or disability or health assurance on your life to this or any other insurance office ever been declined, postponed or accepted with special conditions (for example loading or exclusions)?",
                    "b) Have you ever made a claim or intend to make a claim on the insurance policies (for example, for critical illness/disorder, disability, terminal illness, accident, hospitalisation)?",
                  ]}
                  inputs={["Exclusions", "ClaimInsurancePolicies"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={2}
                  data={data}
                  groupNumber={2}
                  questions={[
                    "Are you now receiving or considering to receive medical treatment from a doctor or intending to consult any doctor for any reason?",
                  ]}
                  inputs={["MedTreatment"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={3}
                  data={data}
                  groupNumber={3}
                  questions={[
                    "Have you ever undergone any health screening or had any medical investigations carried out, whether on your own accord or on the recommendation of a doctor, such as X-ray, ultrasound, electrocardiogram (ECG), barium meal examination, CT scan, biopsy, blood or urine test, etc., in the past 5 years?",
                  ]}
                  inputs={["DiagnosisInfo"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={4}
                  data={data}
                  groupNumber={4}
                  questions={[
                    "Have you been advised to undergo any diagnostic test or surgical operation that has not yet been performed? Do you intend to have any tests or investigations in the coming year?",
                  ]}
                  inputs={["PendingMedTreatment"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={5}
                  data={data}
                  groupNumber={5}
                  questions={[
                    "Have you ever taken addictive drugs, narcotics, glue sniffing or been treated for drug addiction?",
                  ]}
                  inputs={["DrugAddiction"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={6}
                  data={data}
                  groupNumber={6}
                  questions={["Have you ever had or been treated for alcoholism?"]}
                  inputs={["Alcoholism"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={7}
                  data={data}
                  groupNumber={7}
                  questions={[
                    "Have you ever had or been told to have or been treated for:",
                    "a. Diabetes, thyroid disorders, or any other endocrine disorders?",
                    "b. Asthma, persistent cough, coughing with blood, pneumonia, tuberculosis, bronchitis, chest or breathing complaints or discomfort, and / or any other lung disorders?",
                    "c. Raised cholesterol, high blood pressure, heart attack, rheumatic fever, Kawasaki disease, heart murmur, palpitation, coronary artery disease, mitral valve prolapse, or other heart valve disorders, breathlessness, irregular or fast heart rate, chest discomfort or chest pain, and/or any disease or disorders of the heart or blood vessels?",
                    "d. Epilepsy, fits, stroke, paralysis, dementia, Parkinson's disease, multiple sclerosis, motor neurone disease, weakness of limbs, polio, fainting spells, prolonged headache, unconsciousness, nervous breakdown, depression, or any other nervous or mental disorders, or disease of the brain?",
                    "e. Gastritis, stomach or duodenal ulcer, blood in the stools, fistula, hernia, haemorrhoids or piles, irritable bowel syndrome, or any other stomach or bowel disorders?",
                    "f. Jaundice, hepatitis B carrier or any form of hepatitis, liver disorder or gall bladder disorder?",
                    "g. Albumin or protein in urine, blood or sugar in urine, kidney stones, infection or any other disorders of the kidney, bladder, urinary or genital organs?",
                    "h. Slipped disc, gout, any form of arthritis, joint pain or deformity, and/or disorders of the muscles, spine, limbs or joints or severe injury?",
                    "i. Anaemia, any other disorders of the blood, advised to abstain from donating blood, or received blood transfusion or blood products on account of haemophilia or any other reason?",
                    "j. Ear discharge, nose bleeds, double vision, or visual impairment or impaired hearing or speech, or any other disorders of the ear, nose, or throat?",
                    "k. Cancer, tumours, cysts or growths of any kind?",
                    "l. Congenital anomalies, physical disability or any unusual skin lesions, or any other illness, disorder, operation, hospital admission, accident or injury not mentioned above?",
                  ]}
                  inputs={[
                    undefined,
                    "EndocrineDisorder",
                    "LungDisorder",
                    "HeartDisorder",
                    "MentalDisorders",
                    "BowelDisorder",
                    "GallbladderDisorder",
                    "KidneyDisorder",
                    "PhysicalInjury",
                    "BloodDisorder",
                    "HearingAndSight",
                    "Cancer",
                    "PhysicalDisability",
                  ]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={8}
                  data={data}
                  groupNumber={8}
                  questions={[
                    "Have you or your spouse been told to have, or received any medical advice or counselling or treatment in connection with sexually transmitted disease, AIDS, or AIDS Related Complex or any other AIDS related condition?",
                  ]}
                  inputs={["SexualDisease"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={9}
                  data={data}
                  groupNumber={9}
                  questions={[
                    "a. Have you ever had HIV testing done? (If Yes, please state reason and result under Section VI.)",
                    "b. Have you ever in the last 3 months had any of the following symptoms for more than one week continuously: fatigue, weight loss, diarrhoea, enlarged nodes or unusual skin lesions?",
                  ]}
                  inputs={["HIVTesting", "WeightLoss"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />

                <RadioButtonGroup
                  key={10}
                  data={data}
                  groupNumber={10}
                  questions={[
                    <React.Fragment key="doctor">
                      <div>Do you have a regular attending doctor? </div>
                      If Yes, please state the name of the doctor
                      <InputField
                        name="RegularDoctorName"
                        {...data["RegularDoctorName"]}
                        style={{ width: 155 }}
                      />
                      <div>
                        and the address of clinic
                        <TextareaField
                          name="RegularClinicAddress"
                          {...data["RegularClinicAddress"]}
                          style={{ width: 300 }}
                        />
                      </div>
                    </React.Fragment>,
                  ]}
                  inputs={["RegularDoc"]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={11}
                  data={data}
                  groupNumber={11}
                  questions={[
                    <strong key="female">
                      FOR FEMALE ONLY (Also to be completed for child(ren) aged 12 years & above)
                    </strong>,
                    "a. Have you ever been found to have or are you aware of any breast lumps or any other disease or disorders of the breast?",
                    "b. Have you ever suffered from irregular or painful or unusually heavy menstruation, fibroids, cysts or any other disorders of the female organs?",
                    "c. Have you ever had any abnormal pap smear test or been told by any doctor to have a repeat pap smear within the next six months?",
                    "d. Have you been advised to have a mammogram, biopsy, operation of the breasts, ultrasound of the pelvis or any other gynaecological investigations?",
                    "e. Are you pregnant now?",
                    "If Yes, please state the weeks/months of pregnancy.",
                    "f. Were there any complications during any of your pregnancy(ies) such as gestational diabetes, hypertension, etc?",
                  ]}
                  inputs={[
                    undefined,
                    "BreastDisorder",
                    "MenstruationDisorder",
                    "PapSmearDisorder",
                    "GynaecologicalDisorder",
                    "Pregnant",
                    ({ prefix }) => (
                      <React.Fragment key={`${prefix}PregnantDuration`}>
                        <td
                          style={{
                            textAlign: "center",
                            borderLeft: "1px solid",
                          }}
                        >
                          <InputField
                            name={`${prefix}PregnantDurationValue`}
                            {...data[`${prefix}PregnantDurationValue`]}
                            style={{ width: "40px", textAlign: "center" }}
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            borderRight: "1px solid",
                          }}
                        >
                          <SelectField
                            name={`${prefix}PregnantDurationUnit`}
                            id={`${prefix}PregnantDurationUnit`}
                            items={[
                              { value: "Weeks", label: "Weeks" },
                              { value: "Months", label: "Months" },
                            ]}
                          />
                        </td>
                      </React.Fragment>
                    ),
                    "PregnantComplication",
                  ]}
                  prefixes={["Emp", "Sp", "Ch"]}
                />
                <RadioButtonGroup
                  key={12}
                  data={data}
                  groupNumber={12}
                  questions={[
                    <strong key="lifeinsured">
                      {"To answer this question if the Life to be Insured's age is 1 and below."}
                    </strong>,
                    <div key="ChName1YearOldAndBelow">
                      12.1 Name of Life to be Insured:
                      <InputField
                        name="ChName1YearOldAndBelow"
                        {...data["ChName1YearOldAndBelow"]}
                        style={{ width: 150 }}
                      />
                    </div>,
                    <div key="premature">
                      <p>
                        12.2 Is the Life to be Insured a premature baby (i.e less than 37 weeks of
                        gestation)? If yes, please state the following information obtainable from
                        the Child Health Booklet.
                      </p>
                      <div>
                        <div style={{ padding: "5px 0px" }}>a) Gestation Period:</div>
                        <InputField
                          name="ChGestationPeriod"
                          {...data["ChGestationPeriod"]}
                          style={{ width: 150 }}
                          postfix="weeks"
                        />
                        <div style={{ padding: "5px 0px" }}>b) Weight and Length at Birth:</div>
                        <InputField
                          name="ChWeight"
                          {...data["ChWeight"]}
                          style={{ width: 150 }}
                          postfix="weight"
                        />
                        <div style={{ padding: "5px 0px" }}>
                          <InputField
                            name="ChLength"
                            {...data["ChLength"]}
                            style={{ width: 150 }}
                            postfix="length"
                          />
                        </div>
                        <div style={{ padding: "5px 0px" }}>c) APGAR score at</div>
                        <InputField
                          name="ChAPGARscore1min"
                          {...data["ChAPGARscore1min"]}
                          style={{ width: 150 }}
                          postfix="1 minute"
                        />
                        <div style={{ padding: "5px 0px" }} />
                        <InputField
                          name="ChAPGARscore5min"
                          {...data["ChAPGARscore5min"]}
                          style={{ width: 150 }}
                          postfix="5 minutes"
                        />
                      </div>
                    </div>,
                    <div key="pregnancy_events">
                      12.3 Were there significant events during pregnancy/delivery such as but not
                      limited to birth difficulty, congenital deformities, lack of mental
                      development, respiratory distress syndrome, prolonged neonatal jaundice, G6PD
                      deficiency, respiratory disorder? If yes, please provide details below.
                      <TextareaField
                        name="ChPregnancyDisorderInfo"
                        {...data["ChPregnancyDisorderInfo"]}
                        style={{ width: 300 }}
                      />
                    </div>,
                    <div key="pregnancy_events">
                      12.4 Has the child been advised or been told to go for further follow up or
                      further evaluation after each routine assessment check? If yes, please provide
                      details below.
                      <TextareaField
                        name="ChFurtherEvaluationInfo"
                        {...data["ChFurtherEvaluationInfo"]}
                        style={{ width: 300 }}
                      />
                    </div>,
                    <React.Fragment key="routine_check">
                      <div style={{ padding: "5px 0px" }}>
                        12.5 Date and result of last routine check.
                      </div>
                      Date:
                      <InputField
                        name="ChRoutineCheckDate"
                        {...data["ChRoutineCheckDate"]}
                        style={{ width: 150 }}
                      />
                      <div style={{ padding: "5px 0px" }}>
                        Result:
                        <InputField
                          name="ChRoutineCheckResult"
                          {...data["ChRoutineCheckResult"]}
                          style={{ width: 150 }}
                        />
                      </div>
                    </React.Fragment>,
                  ]}
                  inputs={[
                    undefined,
                    undefined,
                    "Premature",
                    "PregnancyDisorder",
                    "FurtherEvaluation",
                    undefined,
                  ]}
                  prefixes={[undefined, undefined, "Ch"]}
                />
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td />
        </tr>
      </tbody>
    </table>
  );
};

Part5.propTypes = {
  data: PropTypes.shape({}),
};

export default Part5;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/GEHD201808/Part5.js